import { createFileRoute, Link } from '@tanstack/react-router'
import { Card } from '@/src/components/ui/card'

export const Route = createFileRoute('/_static/docs/')({
  component: DocsIndexPage,
})

function DocsIndexPage() {
  return (
    <>
      <Card className="mb-4 p-4">
        <div className="flex items-center gap-4">
          <Link
            to="/docs/quickstart"
            className="font-semibold text-base min-w-[180px]"
          >
            Quickstart
          </Link>
          <p className="text-sm text-muted-foreground">
            Get started quickly with Gear Lens. The merge editor is described at
            the end.
          </p>
        </div>
      </Card>
      <Card className="mb-4 p-4">
        <div className="flex items-center gap-4">
          <Link
            to="/docs/api"
            className="font-semibold text-base min-w-[180px]"
          >
            API: Image Analysis
          </Link>
          <p className="text-sm text-muted-foreground">
            How to trigger image analysis and use tasks/templates.
          </p>
        </div>
      </Card>
      <Card className="mb-4 p-4">
        <div className="flex items-center gap-4">
          <Link
            to="/docs/templates"
            className="font-semibold text-base min-w-[180px]"
          >
            Creating New Templates
          </Link>
          <p className="text-sm text-muted-foreground">
            Guide to creating and managing result templates.
          </p>
        </div>
      </Card>
      <Card className="mb-4 p-4">
        <div className="flex items-center gap-4">
          <Link
            to="/docs/storage"
            className="font-semibold text-base min-w-[180px]"
          >
            Custom Storage Solutions
          </Link>
          <p className="text-sm text-muted-foreground">
            How to configure your own S3 bucket for data storage.
          </p>
        </div>
      </Card>
    </>
  )
}
